<router-outlet></router-outlet>
<router-outlet name="popup"></router-outlet>
<router-outlet name="panel"></router-outlet>
